import React from "react";
import styled from "styled-components";

const PrivacyPolicy = () => {
  return (
    <Wrapper>
      <Card>
        <Title>Privacy Policy</Title>
        <Updated>Last updated: {new Date().toLocaleDateString()}</Updated>

        <Section>
          <SectionTitle>1. Information We Collect</SectionTitle>
          <Text>
            We collect personal details such as name, email, phone number,
            and shipping address when you place an order on our website.
          </Text>
        </Section>

        <Section>
          <SectionTitle>2. How We Use Your Information</SectionTitle>
          <Text>
            Your information is used to process orders, provide customer support,
            improve our services, and send updates related to your purchases.
          </Text>
        </Section>

        <Section>
          <SectionTitle>3. Data Protection</SectionTitle>
          <Text>
            We implement appropriate security measures to protect your personal
            data from unauthorized access, misuse, or disclosure.
          </Text>
        </Section>

        <Section>
          <SectionTitle>4. Sharing of Information</SectionTitle>
          <Text>
            We do not sell or trade your personal information. Data may be shared
            with trusted delivery partners to fulfill your orders.
          </Text>
        </Section>

        <Section>
          <SectionTitle>5. Cookies</SectionTitle>
          <Text>
            Our website uses cookies to enhance user experience, track usage,
            and improve website functionality.
          </Text>
        </Section>

        <Section>
          <SectionTitle>6. Your Rights</SectionTitle>
          <Text>
            You have the right to access, update, or delete your personal data.
            You can contact us for any data-related requests.
          </Text>
        </Section>

        <Section>
          <SectionTitle>7. Contact Us</SectionTitle>
           <Text>Email: info@cianahome.com</Text>
        </Section>

      </Card>
    </Wrapper>
  );
};

const Wrapper=styled.section`
  background: ${({ theme }) => theme.colors.bgl};
  min-height: 100vh;
  padding: 40px 20px;
`;

const Card = styled.div`
  max-width: 900px;
  margin: auto;
  background: #fff;
  padding: 3rem;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
`;

const Title = styled.h1`
  text-align: center;
  margin-bottom: 1rem;
  font-size: 3rem;
`;

const Updated = styled.p`
  text-align: center;
  font-size: 1rem;
  margin-bottom: 30px;
`;

const Section = styled.div`
  margin-top: 25px;
`;

const SectionTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
`;

const Text = styled.p`
  margin-top: 8px;
  line-height: 1.8rem ;
  text-align: justify;
  `;


export default PrivacyPolicy;